import { AdviceServicesStyle } from './advice-services.style';
import { IconCard, IconCardProps } from '@exploration/shared-components';
import 'animate.css';
import { Fragment } from 'react';

const {
  Section,
  Container,
  Title,
  CTAsContainer,
  CategoryBadge,
  BoxContainer,
  Description,
} = AdviceServicesStyle;

export interface AdviceCardProps extends IconCardProps {
  badgeLabel: string;
}
export interface AdviceServicesProps {
  title: string;
  description: string;
  cards: AdviceCardProps[];
  id?: string;
}

const AdviceServices = ({
  title,
  description,
  cards,
  id,
}: AdviceServicesProps) => {
  return (
    <Section id={id}>
      <Container>
        <Title as="h2">{title}</Title>
        <Description>{description}</Description>
        <CTAsContainer>
          {cards.map((cta, index) => (
            <Fragment key={cta.icon}>
              <BoxContainer>
                <CategoryBadge
                  label={cta.badgeLabel}
                  size="small"
                  type="neutral"
                />
                <IconCard {...cta} buttonType="link" />
              </BoxContainer>
            </Fragment>
          ))}
        </CTAsContainer>
      </Container>
    </Section>
  );
};

export default AdviceServices;
